import { PaginationFooter } from '../../audit/PaginationFooter';
import { PAGE_SIZE, type useBookingsList } from '../useBookingsListState';

/** The shared pager, wrapped in an `.nb-dashboards` island so its `--nb-*`
 *  tokens + `.nb-btn` styling resolve outside the dashboards scope. */
export function BookingPager({ s }: { s: ReturnType<typeof useBookingsList> }) {
  const { pager } = s;
  return (
    <div className="nb-dashboards mt-2 rounded-xl">
      <PaginationFooter
        offset={pager.offset}
        total={s.totalCount}
        count={s.bookings.length}
        currentPage={pager.currentPage}
        pageCount={pager.pageCount}
        hasPrev={pager.hasPrev}
        hasNext={pager.hasNext}
        onPrev={pager.prevPage}
        onNext={pager.nextPage}
        onPageSelect={(p) => pager.setOffset((p - 1) * PAGE_SIZE)}
      />
    </div>
  );
}
